import { articles as rawArticles } from "@/mocks/articles";
import { topics as rawTopics } from "@/mocks/topics";
import type { Article, Topic } from "@/types/content";

export const articles = rawArticles as unknown as Article[];
export const topics = rawTopics as unknown as Topic[];

export const getArticleById = (id: string): Article | undefined =>
  articles.find((item) => item.id === id);

export const getTopicById = (id: string): Topic | undefined =>
  topics.find((item) => item.id === id);

export const getArticlesByTopic = (topicId: string): Article[] =>
  articles.filter((item) => item.topicId === topicId);

export const searchArticles = (keyword: string): Article[] => {
  const key = keyword.trim();
  if (!key) return articles;
  return articles.filter(
    (item) =>
      item.title.includes(key) ||
      item.summary.includes(key) ||
      item.topicName.includes(key) ||
      item.tags.some((tag) => tag.includes(key))
  );
};

export const getRelatedArticles = (current: Article, limit = 3): Article[] => {
  const sameTopic = articles.filter(
    (item) => item.id !== current.id && item.topicId === current.topicId
  );
  const others = articles.filter(
    (item) => item.id !== current.id && item.topicId !== current.topicId
  );
  return [...sameTopic, ...others].slice(0, limit);
};

export const hotArticles = (limit = 5): Article[] => {
  const parse = (views: string) => Number.parseFloat(views.replace(/[^\d.]/g, "")) || 0;
  return [...articles].sort((a, b) => parse(b.views) - parse(a.views)).slice(0, limit);
};